export default "__VITE_ASSET__BphHnLO4__"